import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SignatureBox from 'components/SignatureBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../reducers';

class InstallerSignature extends Resetter(Validator(React.Component)) {
  state = {
    installerSignature: this.props.installerSignature || '',
    clearInstallerSignature: 0,
    errors: {},
  };

  installerSignatureRef = React.createRef();

  componentDidMount = () => this.installerSignatureRef.current.scrollIntoView(false);

  handleSubmit = () => {
    const checks = {
      installerSignature: true,
    };
    if (!this.validate(checks)) { return; }

    const { installerSignature } = this.state;
    this.props.updateFormData({
      installerSignature, tab: 7,
    });
  }

  handlePrevious = () => {
    const tab = this.props.step === 'pre' ? 5 : 4;
    const { installerSignature } = this.state;
    this.props.updateFormData({
      installerSignature, tab,
    });
  }

  handleInstallerSignature = data => this.setState({ installerSignature: data });

  handleInstallerClear = () => {
    this.setState({
      installerSignature: '',
      clearInstallerSignature: this.props.installerSignature
        ? this.state.clearInstallerSignature : Date.now(),
    });
    this.props.updateFormData({ installerSignature: '' });
  }

  render = () => {
    const { isSpanish, installerSignature } = this.props;
    const { errors, clearInstallerSignature } = this.state;

    return (<div ref={this.installerSignatureRef}>
      <h6>
        {isSpanish ? 'Firma del instalador' : 'Installer Signature'}
      </h6>
      <SignatureBox
        label={isSpanish
          ? 'Firmar el nombre del instalador*'
          : 'Sign Installer\'s Name*'
        }
        required
        value={installerSignature}
        errors={errors.installerSignature}
        clearTimestamp={clearInstallerSignature}
        onEnd={this.handleInstallerSignature}
        onClear={this.handleInstallerClear}
      />
      <Button
        label={isSpanish ? 'Próximo' : 'Next'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <Button
        label={isSpanish ? 'Anterior' : 'Previous'}
        flat inverse ripple
        className={S.submit}
        onClick={this.handlePrevious}
      />
    </div>);
  }
}

InstallerSignature.propTypes = {
  step: PropTypes.bool,
  isSpanish: PropTypes.bool,
  installerSignature: PropTypes.string,
  errors: PropTypes.shape({
    installerSignature: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(InstallerSignature);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/installerSignature.jsx